const PROJECT_TYPE_LABELS = {
  web: 'Web',
  mobile: 'Mobile',
  desktop: 'Desktop',
  embedded: 'Embedded',
  api_backend: 'API / Backend',
  apibackend: 'API / Backend',
  cloud_devops: 'Cloud DevOps',
  clouddevops: 'Cloud DevOps',
  iot: 'IoT',
  none: 'None',
  'not_specified': 'Not specified',
};

const PROJECT_TYPE_CLASS_ALIASES = {
  web: 'type-web',
  mobile: 'type-mobile',
  desktop: 'type-desktop',
  embedded: 'type-embedded',
  api_backend: 'type-api-backend',
  apibackend: 'type-api-backend',
  cloud_devops: 'type-cloud-devops',
  clouddevops: 'type-cloud-devops',
  iot: 'type-iot',
  none: 'type-none',
  'not_specified': 'type-none',
};

export function normalizeProjectType(type) {
  if (!type) return 'none';
  return String(type).trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function formatProjectTypeLabel(type) {
  const normalized = normalizeProjectType(type);
  if (PROJECT_TYPE_LABELS[normalized]) {
    return PROJECT_TYPE_LABELS[normalized];
  }

  return String(type)
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getProjectTypeClass(type) {
  const normalized = normalizeProjectType(type);
  return PROJECT_TYPE_CLASS_ALIASES[normalized] || 'type-none';
}
